var slideSwitch = function (destination, 
    opacity, 
    zindex, 
    width, 
    borderWidth, 
    display, 
    dark, 
    borderImage, 
    linear, 
    scroll,
    bicolor,
    bicolorWhite) {
    $('.square_home').css({
        'display': display,
        'width': width,
        'height': width,
        'opacity': opacity,
        'z-index': zindex,
        'border-width': borderWidth
    });

    (borderImage) ? $('.square_home').css('filter', 'grayscale(.95)'): $('.square_home').css('filter', 'none');

    if (dark) {
        $('.header').addClass('header-dark');
    } else {
        $('.header').removeClass('header-dark');
    }
    if (linear) {
        $('.header').addClass('header-linear');
    } else {
        $('.header').removeClass('header-linear');

    }

    if(bicolor){
        $('.menuLeft').addClass('colorDark');
        $('.logotype').addClass('colorDark');
    } else{
        $('.menuLeft').removeClass('colorDark');
        $('.logotype').removeClass('colorDark');
    }
    if(bicolorWhite){
        $('.menuRight').addClass('colorLight');
    } else{
        $('.menuRight').removeClass('colorLight');
    }
}

var slidesData = {
    firstPage: ['1', '.5', '1', '33.33vw', '8.25vw', 'flex', false, false, false, false, false,true],
    sectionHow: ['1', '.5', '1', '33.33vw', '8.25vw', 'flex', false, false, false, false, true],
    secondPage: ['1', '.5', '1', '33.33vw', '8.25vw', 'flex', false,false, false, false, true],
    sectionTeam: ['1', '.2', '0', '33.33vw', '8.25vw', 'flex', true, false, false, false, false],
    sectionClients: ['1', '.2', '1', '33.33vw', '8.25vw', 'flex', true, false,false, false, false],
    sectionIdeas: ['1', '0', '1', '33.33vw', '8.25vw', 'flex', true, false, true],
    sectionSmart: ['1', '0', '1', '33.33vw', '16.5vw', 'flex', true, false, true],
    // sectionAlumni: ['1', '0', '1', '33.33vw', '1px', 'flex', false, false, true, true, true, true],
    sectionHire: ['1', '.7', '1', '33.33vw', '8.25vw','flex', true, false, true ],
    // sectionWhat: ['1', '1', '1', '33.33vw', '8.25vw', 'flex', false],
    sectionMap: ['1', '.5', '1', '33.33vw', '8.25vw', 'flex', false, false, false, false, false,true],
}